import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ListaPoiComponent } from './pages/lista-poi/lista-poi.component';
import { ListaItinerariComponent } from './pages/lista-itinerari/lista-itinerari.component';
import { MapComponent } from './pages/map/map.component';
import { PoiSingoloComponent } from './components/poi-singolo/poi-singolo.component';
import { ItinerarioSingoloComponent } from './components/itinerario-singolo/itinerario-singolo.component';
import { AboutComponent } from './pages/about/about.component';
import { PoiPageComponent } from './pages/poi-page/poi-page.component';
import { SinglePoiPageComponent } from './components/single-poi-page/single-poi-page.component';
import { ItineraryPageComponent } from './pages/itinerary-page/itinerary-page.component';
import { SingleItineraryPageComponent } from './components/single-itinerary-page/single-itinerary-page.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { ListaUtentiComponent } from './pages/lista-utenti/lista-utenti.component';
import { UtenteSingoloComponent } from './components/utente-singolo/utente-singolo.component';
import { NewPoiComponent } from './components/new-poi/new-poi.component';
import { NewItinComponent } from './components/new-itin/new-itin.component';
import { NewUserComponent } from './components/new-user/new-user.component';
import { NewThemeComponent } from './components/new-theme/new-theme.component';
import { ListaToApproveComponent } from './pages/lista-to-approve/lista-to-approve.component';
import { ListaThemesComponent } from './pages/lista-themes/lista-themes.component';
import { ThemeSingoloComponent } from './components/theme-singolo/theme-singolo.component';
import { ApprPoiSingoloComponent } from './components/appr-poi-singolo/appr-poi-singolo.component';
import { ApprItinSingoloComponent } from './components/appr-itin-singolo/appr-itin-singolo.component';
import { SingleAreaComponent } from './components/single-area/single-area.component';

import { SingleAreaPoisResolver } from './resolvers/single-area-pois.resolver';
import { SingleAreaItinerariesResolver } from './resolvers/single-area-itineraries.resolver';
import { PoiListResolver } from './resolvers/poi-list.resolver';
import { ThemesResolver } from './resolvers/themes.resolver';
import { SinglePoiResolver } from './resolvers/single-poi.resolver';
import { ItinListResolver } from './resolvers/itin-list.resolver';
import { SingleItinResolver } from './resolvers/single-itin.resolver';
import { LoggedUserGuard } from './guards/logged-user.guard';
import { GeoPosResolver } from './resolvers/geopos.resolver';
import { AdminUserGuard } from './guards/admin-user.guard';
import { UserListResolver } from './resolvers/user-list.resolver';
import { SingleUserResolver } from './resolvers/single-user.resolver';
import { SuperadminUserGuard } from './guards/superadmin-user.guard';
import { SingleThemeResolver } from './resolvers/single-theme.resolver';
import { EditablePoiResolver } from './resolvers/editable-poi.resolver';
import { EditableItinResolver } from './resolvers/editable-itin.resolver';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { PoiListAdminResolver } from './resolvers/poi-list-admin.resolver';
import { ItinListAdminResolver } from './resolvers/itin-list-admin.resolver';
import { PoiListUnapprovedAdminResolver } from './resolvers/poi-list-unapproved-admin.resolver';
import { ItinListUnapprovedAdminResolver } from './resolvers/itin-list-unapproved-admin.resolver';
import { PoiCarouselResolver } from './resolvers/poi-carousel.resolver';
import { ItinCarouselResolver } from './resolvers/itin-carousel.resolver';
import { PoisForMapResolver } from './resolvers/pois-for-map.resolver';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', data: { breadcrumb: 'breadcrumb.home' },
    children: [
      { path: '', component: HomeComponent },
      { path: 'aree', data: { breadcrumb: 'breadcrumb.map' },
        children: [
          { path: '', component: MapComponent},
          {
            path: ':name',
            component: SingleAreaComponent,
            data: { breadcrumb: 'breadcrumb.single_area' },
            resolve: {
              themes: ThemesResolver,
              paginatedPois: SingleAreaPoisResolver,
              paginatedItins: SingleAreaItinerariesResolver,
              poisForMap: PoisForMapResolver
            }
          },
        ]},
      { path: 'poi', data: { breadcrumb: 'breadcrumb.poi' },
        children: [
          { path: '',
            component: PoiPageComponent,
            resolve: {
              themes: ThemesResolver,
              pois: PoiListResolver,
              carouselPoi: PoiCarouselResolver
            }},
          { path: ':id',
            component: SinglePoiPageComponent,
            data: { breadcrumb: 'breadcrumb.single_poi' },
            resolve: [SinglePoiResolver]},
        ]},
      { path: 'itinerari', data: { breadcrumb: 'breadcrumb.itin' },
        children: [
          { path: '',
            component: ItineraryPageComponent,
            resolve: {
              themes: ThemesResolver,
              itin: ItinListResolver,
              carouselItin: ItinCarouselResolver
            }},
          { path: ':id',
            component: SingleItineraryPageComponent,
            data: { breadcrumb: 'breadcrumb.single_itin' },
            resolve: [SingleItinResolver]},
        ]},
      { path: 'about', component: AboutComponent, data: { breadcrumb: 'breadcrumb.about' }},
    ]},
  { path: 'lista-poi', data: { breadcrumb: 'breadcrumb.admin_poi' },
    children: [
      { path: '',
        component: ListaPoiComponent,
        resolve: [PoiListAdminResolver], canActivate: [LoggedUserGuard]},
      { path: 'nuovo-poi',
        component: NewPoiComponent,
        data: { breadcrumb: 'breadcrumb.new_poi' },
        resolve: [ThemesResolver, GeoPosResolver], canActivate: [LoggedUserGuard]},
      { path: ':id',
        component: PoiSingoloComponent,
        data: { breadcrumb: 'breadcrumb.admin_single_poi' },
        resolve: [EditablePoiResolver, ThemesResolver, GeoPosResolver], canActivate: [LoggedUserGuard]}
    ]},
  { path: 'lista-itinerari', data: { breadcrumb: 'breadcrumb.admin_itin' },
    children: [
      { path: '',
        component: ListaItinerariComponent,
        resolve: [ItinListAdminResolver], canActivate: [LoggedUserGuard]},
      { path: 'nuovo-itinerario',
        component: NewItinComponent,
        data: { breadcrumb: 'breadcrumb.new_itin' },
        resolve: [ThemesResolver, GeoPosResolver], canActivate: [LoggedUserGuard]},
      { path: ':id',
        component: ItinerarioSingoloComponent,
        data: { breadcrumb: 'breadcrumb.admin_single_itin' },
        resolve: [EditableItinResolver, ThemesResolver, GeoPosResolver], canActivate: [LoggedUserGuard]}
    ]},
  { path: 'lista-utenti', data: { breadcrumb: 'breadcrumb.admin_user' },
    children: [
      { path: '',
        component: ListaUtentiComponent,
        resolve: [UserListResolver], canActivate: [AdminUserGuard]},
      { path: 'nuovo-utente',
        component: NewUserComponent,
        data: { breadcrumb: 'breadcrumb.new_user' },
        resolve: [GeoPosResolver], canActivate: [AdminUserGuard]},
      { path: ':id',
        component: UtenteSingoloComponent,
        data: { breadcrumb: 'breadcrumb.admin_single_user' },
        resolve: [SingleUserResolver, GeoPosResolver], canActivate: [AdminUserGuard]}
    ]},
  { path: 'lista-percorsi-tematici', data: { breadcrumb: 'breadcrumb.admin_themes' },
    children: [
      { path: '',
        component: ListaThemesComponent,
        resolve: [ThemesResolver], canActivate: [SuperadminUserGuard]},
      { path: 'nuovo-percorso',
        component: NewThemeComponent,
        data: { breadcrumb: 'breadcrumb.new_theme' }, canActivate: [SuperadminUserGuard]},
      { path: ':id',
        component: ThemeSingoloComponent,
        data: { breadcrumb: 'breadcrumb.admin_single_theme' },
        resolve: [SingleThemeResolver], canActivate: [SuperadminUserGuard]}
    ]},
  { path: 'cambio-password', data: { breadcrumb: 'breadcrumb.admin_pwd' },
    children: [
      { path: '',
        component: ChangePasswordComponent,
        canActivate: [LoggedUserGuard]},
    ]},
  { path: 'lista-da-approvare', data: { breadcrumb: 'breadcrumb.admin_to_approve' },
    children: [
      { path: '',
        component: ListaToApproveComponent,
        resolve: [PoiListUnapprovedAdminResolver, ItinListUnapprovedAdminResolver, UserListResolver], canActivate: [AdminUserGuard]},
      { path: 'poi/:id',
        component: ApprPoiSingoloComponent,
        data: { breadcrumb: 'breadcrumb.admin_single_poi_appr' },
        resolve: [EditablePoiResolver, ThemesResolver, GeoPosResolver], canActivate: [AdminUserGuard]},
      { path: 'itinerari/:id',
        component: ApprItinSingoloComponent,
        data: { breadcrumb: 'breadcrumb.admin_single_itin_appr' },
        resolve: [EditableItinResolver, ThemesResolver, GeoPosResolver], canActivate: [AdminUserGuard]}
    ]},
  { path: '**', component: PageNotFoundComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
